import type { PlaylistItem, VariantType } from '../types';

export function getPreferredPlaylistItemVariant(
  playlistItem: PlaylistItem | undefined,
  preferredVariants: VariantType[],
) {
  if (!playlistItem) {
    return undefined;
  }
  for (const variantType of preferredVariants) {
    const variant = playlistItem.availableVariants?.find(
      (candidate) => candidate.type === variantType,
    );
    if (variant) {
      return variant;
    }
  }

  return undefined;
}
